import { Icon, ItemGroup, SmallTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import { color, padding } from '@sleepstation/style-api-helpers'
import { defaultBorder } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)``

const Body = styled.div`
  ${padding([0.5, 1])}
`

const Title = styled(SmallTitle)`
  ${color(`inlineLink`)}
`

const Footer = styled(HLayout).attrs({
  as: `footer`,
  align: LAYOUT_ALIGN.CENTER,
  spacing: LAYOUT_SPACING.BETWEEN,
})`
  ${padding([
    [0.75, 0.5],
    [0.75, 1],
  ])}
  ${defaultBorder(`top`)}
  ${color(`body`)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Content = ({ title, bodyAst, linkLabel }) => (
  <Layout>
    <Body>
      <ItemGroup title={title} spacing={0.5}>
        <CopyRenderer htmlAst={bodyAst} />
      </ItemGroup>
    </Body>
    <Footer>
      <Title>{linkLabel}</Title>
      <Icon name="linkAlt" size={SIZE.LARGE} />
    </Footer>
  </Layout>
)

Content.propTypes = {
  title: PropTypes.string.isRequired,
  bodyAst: PropTypes.object.isRequired,
  linkLabel: PropTypes.string.isRequired,
}

export default Content
